const PATHS = {
  HOME: "/",
  APP: "/app",
  ADMIN: "/admin",
  ADMIN_USER_DETAIL: "/admin/:userId/:closetId",
  AFFILIATE_PROGRAM: "/affiliate-program",
  APP_DOWNLOAD: "/app-download",
  IMAGE_GEN: "/image-gen",
  PRIVACY: "/privacy",
  TERMS_AND_CONDITIONS: "/terms-and-conditions",
  SIGN_IN: "/sign-in",
  REGISTER: "/register",
  SETTINGS: "/settings",
  PREMIUM_UNLOCKED: "/premium-unlocked",
  GUIDES: "/guides",
  FEE_CALCULATOR: "/poshmark-fee-calculator",
  EBAY_FEE_CALCULATOR: "/ebay-fee-calculator",
  POSHMARK_ASSISTANT: "/poshmark-assistant",
  MOBILE_APP: "/mobile-app",
  CLOSET_SHARER: "/closet-sharer",
  PRODUCT_RESEARCH: "/product-research",
  TRENDING: "/trending",
  LISTING_ASSISTANT: "/listing-assistant",
  COMPARE_LISTINGS: "/compare-listings",
  POST_GENERATOR: "/post-generator",
  UNSUBSCRIBE: "/unsubscribe",
  RANK_CHECKER: "/listing-rank-checker",
  TOP_BRANDS: "/top-selling-brands-on-poshmark",
  TOP_BRANDS_SHORT: "/brand",
  TOP_SELLERS: "/top-sellers-on-poshmark",
  TOP_SELLERS_SHORT: "/seller",
  TOP_CATEGORIES: "/top-categories-on-poshmark",
  TOP_CATEGORIES_SHORT: "/category",
  LISTING_ANALYZER: "/listing-analyzer",
  PRICING: "/pricing",
  POSHMARK_LISTING_ANALYZER: "/listing-analyzer-poshmark",
  DEPOP_LISTING_ANALYZER: "/listing-analyzer-depop",
  MERCARI_LISTING_ANALYZER: "/listing-analyzer-mercari",
  EBAY_LISTING_ANALYZER: "/listing-analyzer-ebay",
  GRAILED_LISTING_ANALYZER: "/listing-analyzer-grailed",
  STYLE_GLOSSARY: "/style-glossary",
  SELLERS: "/seller/:username",
  BRAND: "/brand/:brand",
  CATEGORY: "/category/:category",
  CATEGORIES: [
    { name: "Shoes", path: "/category/shoes" },
    { name: "Tops", path: "/category/tops" },
    { name: "Pants & Jumpsuits", path: "/category/pants-and-jumpsuits" },
    { name: "Bags", path: "/category/bags" },
    { name: "Jackets & Coats", path: "/category/jackets-and-coats" },
    { name: "Jeans", path: "/category/jeans" },
    { name: "Dresses", path: "/category/dresses" },
    { name: "Sweaters", path: "/category/sweaters" },
    { name: "Accessories", path: "/category/accessories" },
    { name: "Shirts", path: "/category/shirts" }
  ],
  BRANDS: [
    { name: "7 For All Mankind", path: "/brand/7-for-all-mankind" },
    { name: "A New Day", path: "/brand/a-new-day" },
    { name: "Abercrombie & Fitch", path: "/brand/abercrombie-and-fitch" },
    { name: "Adidas", path: "/brand/adidas" },
    { name: "Aerie", path: "/brand/aerie" },
    { name: "Agolde", path: "/brand/agolde" },
    { name: "Alice + Olivia", path: "/brand/alice-+-olivia" },
    { name: "All Saints", path: "/brand/all-saints" },
    { name: "Alo Yoga", path: "/brand/alo-yoga" },
    { name: "American Eagle Outfitters", path: "/brand/american-eagle-outfitters" },
    { name: "Anine Bing", path: "/brand/anine-bing" },
    { name: "Anthropologie", path: "/brand/anthropologie" },
    { name: "Apple", path: "/brand/apple" },
    { name: "Arc'teryx", path: "/brand/arcteryx" },
    { name: "Ariat", path: "/brand/ariat" },
    { name: "Aritzia", path: "/brand/aritzia" },
    { name: "ASICS", path: "/brand/asics" },
    { name: "Athleta", path: "/brand/athleta" },
    { name: "Aviator Nation", path: "/brand/aviator-nation" },
    { name: "Badgley Mischka", path: "/brand/badgley-mischka" },
    { name: "Baggu", path: "/brand/baggu" },
    { name: "Balenciaga", path: "/brand/balenciaga" },
    { name: "Banana Republic", path: "/brand/banana-republic" },
    { name: "Barbour", path: "/brand/barbour" },
    { name: "Bellanblue", path: "/brand/bellanblue" },
    { name: "Betsey Johnson", path: "/brand/betsey-johnson" },
    { name: "Birkenstock", path: "/brand/birkenstock" },
    { name: "Blundstone", path: "/brand/blundstone" },
    { name: "Boden", path: "/brand/boden" },
    { name: "Bottega Veneta", path: "/brand/bottega-veneta" },
    { name: "Brahmin", path: "/brand/brahmin" },
    { name: "Brooks", path: "/brand/brooks" },
    { name: "Burberry", path: "/brand/burberry" },
    { name: "Calvin Klein", path: "/brand/calvin-klein" },
    { name: "Canada Goose", path: "/brand/canada-goose" },
    { name: "Carhartt", path: "/brand/carhartt" },
    { name: "Cartier", path: "/brand/cartier" },
    { name: "Celine", path: "/brand/celine" },
    { name: "Chanel", path: "/brand/chanel" },
    { name: "Chloe", path: "/brand/chloe" },
    { name: "Christian Louboutin", path: "/brand/christian-louboutin" },
    { name: "Chrome Hearts", path: "/brand/chrome-hearts" },
    { name: "Clare V.", path: "/brand/clare-v" },
    { name: "Clarks", path: "/brand/clarks" },
    { name: "Coach", path: "/brand/coach" },
    { name: "Cole Haan", path: "/brand/cole-haan" },
    { name: "Columbia", path: "/brand/columbia" },
    { name: "Converse", path: "/brand/converse" },
    { name: "Crocs", path: "/brand/crocs" },
    { name: "Dansko", path: "/brand/dansko" },
    { name: "David Yurman", path: "/brand/david-yurman" },
    { name: "Dior", path: "/brand/dior" },
    { name: "Disney", path: "/brand/disney" },
    { name: "Doen", path: "/brand/doen" },
    { name: "Dolce & Gabbana", path: "/brand/dolce-and-gabbana" },
    { name: "Dolce Vita", path: "/brand/dolce-vita" },
    { name: "Dooney & Bourke", path: "/brand/dooney-and-bourke" },
    { name: "Dr. Martens", path: "/brand/dr-martens" },
    { name: "Dyson", path: "/brand/dyson" },
    { name: "Eileen Fisher", path: "/brand/eileen-fisher" },
    { name: "Everlane", path: "/brand/everlane" },
    { name: "Express", path: "/brand/express" },
    { name: "Farm Rio", path: "/brand/farm-rio" },
    { name: "Fendi", path: "/brand/fendi" },
    { name: "FIGS", path: "/brand/figs" },
    { name: "FP Movement by Free People", path: "/brand/fp-movement-by-free-people" },
    { name: "Franco Sarto", path: "/brand/franco-sarto" },
    { name: "Frank & Eileen", path: "/brand/frank-and-eileen" },
    { name: "Free People", path: "/brand/free-people" },
    { name: "Frye", path: "/brand/frye" },
    { name: "Gap", path: "/brand/gap" },
    { name: "Gildan", path: "/brand/gildan" },
    { name: "Givenchy", path: "/brand/givenchy" },
    { name: "Golden Goose", path: "/brand/golden-goose" },
    { name: "Good American", path: "/brand/good-american" },
    { name: "Goyard", path: "/brand/goyard" },
    { name: "Gucci", path: "/brand/gucci" },
    { name: "Hand Crafted", path: "/brand/hand-crafted" },
    { name: "H&M", path: "/brand/handm" },
    { name: "Harley Davidson", path: "/brand/harley-davidson" },
    { name: "Hermes", path: "/brand/hermes" },
    { name: "Herolife", path: "/brand/herolife" },
    { name: "Hoka", path: "/brand/hoka" },
    { name: "Hoka One One", path: "/brand/hoka-one-one" },
    { name: "House of CB", path: "/brand/house-of-cb" },
    { name: "Hunter", path: "/brand/hunter" },
    { name: "Isabel Marant", path: "/brand/isabel-marant" },
    { name: "J.Crew", path: "/brand/j-crew" },
    { name: "Jeffree Star", path: "/brand/jeffree-star" },
    { name: "Jenni Kayne", path: "/brand/jenni-kayne" },
    { name: "Jimmy Choo", path: "/brand/jimmy-choo" },
    { name: "Johnny Was", path: "/brand/johnny-was" },
    { name: "Jordan", path: "/brand/jordan" },
    { name: "Judy Blue", path: "/brand/judy-blue" },
    { name: "Juicy Couture", path: "/brand/juicy-couture" },
    { name: "Kate Spade", path: "/brand/kate-spade" },
    { name: "Kendra Scott", path: "/brand/kendra-scott" },
    { name: "Kurt Geiger", path: "/brand/kurt-geiger" },
    { name: "L'Agence", path: "/brand/lagence" },
    { name: "Lauren Ralph Lauren", path: "/brand/lauren-ralph-lauren" },
    { name: "Levi's", path: "/brand/levis" },
    { name: "Lilly Pulitzer", path: "/brand/lilly-pulitzer" },
    { name: "L.L.Bean", path: "/brand/ll-bean" },
    { name: "Loewe", path: "/brand/loewe" },
    { name: "Longchamp", path: "/brand/longchamp" },
    { name: "Louis Vuitton", path: "/brand/louis-vuitton" },
    { name: "Loungefly", path: "/brand/loungefly" },
    { name: "LoveShackFancy", path: "/brand/loveshackfancy" },
    { name: "Lucky Brand", path: "/brand/lucky-brand" },
    { name: "Lululemon Athletic", path: "/brand/lululemon-athletic" },
    { name: "Lulus", path: "/brand/lulus" },
    { name: "MAC Cosmetics", path: "/brand/mac-cosmetics" },
    { name: "Mac Duggal", path: "/brand/mac-duggal" },
    { name: "Madewell", path: "/brand/madewell" },
    { name: "Mamachicky", path: "/brand/mamachicky" },
    { name: "Mango", path: "/brand/mango" },
    { name: "Marc Jacobs", path: "/brand/marc-jacobs" },
    { name: "MCM", path: "/brand/mcm" },
    { name: "Michael Kors", path: "/brand/michael-kors" },
    { name: "Michael Michael Kors", path: "/brand/michael-michael-kors" },
    { name: "Miu Miu", path: "/brand/miu-miu" },
    { name: "Moncler", path: "/brand/moncler" },
    { name: "Mother", path: "/brand/mother" },
    { name: "Naturalizer", path: "/brand/naturalizer" },
    { name: "New Balance", path: "/brand/new-balance" },
    { name: "Nike", path: "/brand/nike" },
    { name: "Old Navy", path: "/brand/old-navy" },
    { name: "On Running", path: "/brand/on-running" },
    { name: "Pandora", path: "/brand/pandora" },
    { name: "Patagonia", path: "/brand/patagonia" },
    { name: "Pendleton", path: "/brand/pendleton" },
    { name: "Peter Millar", path: "/brand/peter-millar" },
    { name: "Pink Victoria's Secret", path: "/brand/pink-victorias-secret" },
    { name: "Pol", path: "/brand/pol" },
    { name: "Polo Ralph Lauren", path: "/brand/polo-ralph-lauren" },
    { name: "Prada", path: "/brand/prada" },
    { name: "Puma", path: "/brand/puma" },
    { name: "Quince", path: "/brand/quince" },
    { name: "Rag & Bone", path: "/brand/rag-and-bone" },
    { name: "Ralph Lauren", path: "/brand/ralph-lauren" },
    { name: "Ray-Ban", path: "/brand/ray-ban" },
    { name: "Reformation", path: "/brand/reformation" },
    { name: "Revolution", path: "/brand/revolution" },
    { name: "Rolex", path: "/brand/rolex" },
    { name: "Rothy's", path: "/brand/rothys" },
    { name: "Rouge", path: "/brand/rouge" },
    { name: "Saint Laurent", path: "/brand/saint-laurent" },
    { name: "Salvatore Ferragamo", path: "/brand/salvatore-ferragamo" },
    { name: "Sam Edelman", path: "/brand/sam-edelman" },
    { name: "Self Portrait", path: "/brand/self-portrait" },
    { name: "Sezane", path: "/brand/sezane" },
    { name: "Shark", path: "/brand/shark" },
    { name: "ShopEvelynne", path: "/brand/shopevelynne" },
    { name: "Show Me Your Mumu", path: "/brand/show-me-your-mumu" },
    { name: "Skims", path: "/brand/skims" },
    { name: "Sorel", path: "/brand/sorel" },
    { name: "Spanx", path: "/brand/spanx" },
    { name: "St. John", path: "/brand/st-john" },
    { name: "Staud", path: "/brand/staud" },
    { name: "Steve Madden", path: "/brand/steve-madden" },
    { name: "Stuart Weitzman", path: "/brand/stuart-weitzman" },
    { name: "Swarovski", path: "/brand/swarovski" },
    { name: "Talbots", path: "/brand/talbots" },
    { name: "Tarte", path: "/brand/tarte" },
    { name: "Taylor Swift", path: "/brand/taylor-swift" },
    { name: "The North Face", path: "/brand/the-north-face" },
    { name: "Tiffany & Co.", path: "/brand/tiffany-and-co" },
    { name: "Timberland", path: "/brand/timberland" },
    { name: "Tom Ford", path: "/brand/tom-ford" },
    { name: "Torrid", path: "/brand/torrid" },
    { name: "Tory Burch", path: "/brand/tory-burch" },
    { name: "Tuckernuck", path: "/brand/tuckernuck" },
    { name: "Tumi", path: "/brand/tumi" },
    { name: "UGG", path: "/brand/ugg" },
    { name: "Under Armour", path: "/brand/under-armour" },
    { name: "Universal Thread", path: "/brand/universal-thread" },
    { name: "Urban Outfitters", path: "/brand/urban-outfitters" },
    { name: "Valentino", path: "/brand/valentino" },
    { name: "Valentino Garavani", path: "/brand/valentino-garavani" },
    { name: "Van Cleef & Arpels", path: "/brand/van-cleef-and-arpels" },
    { name: "Vans", path: "/brand/vans" },
    { name: "Veronica Beard", path: "/brand/veronica-beard" },
    { name: "Versace", path: "/brand/versace" },
    { name: "Victoria's Secret", path: "/brand/victorias-secret" },
    { name: "Vince", path: "/brand/vince" },
    { name: "Vince Camuto", path: "/brand/vince-camuto" },
    { name: "Vintage", path: "/brand/vintage" },
    { name: "Vionic", path: "/brand/vionic" },
    { name: "Vivienne Westwood", path: "/brand/vivienne-westwood" },
    { name: "Vuori", path: "/brand/vuori" },
    { name: "We The Free", path: "/brand/we-the-free" },
    { name: "White House Black Market", path: "/brand/white-house-black-market" },
    { name: "Wrangler", path: "/brand/wrangler" },
    { name: "Yves Saint Laurent", path: "/brand/yves-saint-laurent" },
    { name: "Zadig & Voltaire", path: "/brand/zadig-and-voltaire" },
    { name: "Zara", path: "/brand/zara" },
    { name: "Zenana Outfitters", path: "/brand/zenana-outfitters" },
    { name: "Zimmermann", path: "/brand/zimmermann" }
  ],
  GUIDE_PATHS: [
    { name: "AI Photography Tools", path: "/guides/ai-photography-tools" },
    { name: "Where and How to Sell Clothes Online in 2025", path: "/guides/how-to-sell-clothes-online" },
    { name: "Is Poshmark Legit?", path: "/guides/is-poshmark-legit" },
    { name: "Poshmark Lingo Guide", path: "/guides/poshmark-lingo-guide" },
    { name: "Poshmark Shipping Hacks", path: "/guides/poshmark-shipping-hacks" },
    { name: "Poshmark Automation", path: "/guides/poshmark-automation-and-sharing-bots" },
    { name: "How to Start Selling on Poshmark", path: "/guides/how-to-start-selling-on-poshmark" },
    { name: "Top Tools for Resellers", path: "/guides/top-tools-for-poshmark-resellers" },
    { name: "Reseller Tips", path: "/guides/reseller-tips" },
    { name: "Guide to Sharing on Poshmark", path: "/guides/guide-to-sharing-on-poshmark" },
    { name: "Best Time to Share on Poshmark", path: "/guides/the-best-time-to-share-on-poshmark" },
    { name: "Product Research", path: "/guides/product-research" },
    { name: "How to Rank #1 in Poshmark Search", path: "/guides/how-to-rank-1-in-poshmark-search" },
    { name: "How to Create Poshmark Listings that Sell", path: "/guides/how-create-poshmark-listings-that-sell" },
    { name: "How to Take Professional Photos", path: "/guides/how-to-take-professional-poshmark-photos" },
    { name: "How to Take Measurements", path: "/guides/how-to-take-measurements-for-resale" },
    { name: "Poshmark Listing Template", path: "/guides/poshmark-listing-template" },
    { name: "How to List Consistently", path: "/guides/how-to-list-consistently-on-poshmark" },
    { name: "Where to Source Inventory", path: "/guides/where-to-source-poshmark-inventory" },
    { name: "What to Do When You Can't Find Comps", path: "/guides/What-to-do-when-cant-find-poshmark-comps" },
    { name: "Guide to Identifying High Quality Clothing", path: "/guides/reseller-guide-to-identifying-high-quality-clothing" }
  ]
}

export default PATHS;